import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { Usuario } from 'app/domain/usuario';
import { MensajeService } from 'app/modulo_compartido/mensaje/mensaje.service';

// Services
import { LoginService } from './login.service';
import { CSECoreService } from 'app/cse.coreService';

declare var $: any;

@Component({
	moduleId: module.id,
	selector: 'login-app',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
	providers: [LoginService]
})

export class LoginComponent {
	user = new Usuario();

	private key_token = 'key_apm';

	constructor(private loginService: LoginService, private router: Router, private mensaje: MensajeService, private _titulo: Title, private cseCore: CSECoreService) {

	}

	setTitle(titulo: string) {
		this._titulo.setTitle(titulo);
	}

	error_login: boolean = false;
	error_mensaje = "";
	loading = false;

	ngOnInit() {
		this.setTitle("Container Services | Iniciar sesion");
		this.user = new Usuario();
		this.user.usuarioCuenta = "";
		this.user.claveUsuario = "";
		this.loading = false;
		this.enviando = false;
		if (this.loginService.isLogged()) {
			this.router.navigate(['/menu']);
		}
	}

	enviando = false;

	userLogin(login) {
		this.error_login = false;
		this.error_mensaje = "";
		this.loading = true;

		this.loginService.login(login.usuarioCuenta, login.claveUsuario)
			.then(resp => {
				if (resp) {
					window.localStorage.setItem("usuario", JSON.stringify(resp));
					window.localStorage.removeItem("cse_technology");
					window.localStorage.removeItem("cse_modality");
					if (resp.data) {
						this.cseCore.config.add = resp.data;
					}
					this.router.navigate(['/menu']);
					/*
					if (resp.codigoPerfil == "24" || resp.codigoPerfil == "25" || resp.codigoPerfil == "27") {
						this.router.navigate(['/menu']);
					} else {
						this.error_login = true;
						this.error_mensaje = "El Perfil no es el Correcto."
						this.loading = false;
						window.localStorage.removeItem("cse_technology");
						window.localStorage.removeItem("cse_modality");
						window.localStorage.removeItem("key_apm");
						window.localStorage.removeItem("usuario");
					}*/
				} else {
					this.error_login = true;
					this.loading = false;
					this.error_mensaje = "Verificar Credenciales."
				}
			}, error => {
				//console.log(error);
				this.loading = false;
				this.error_mensaje = error;
				this.mensaje.enviarAlerta({ mensaje: error, tipo: 2 });
			});
	}

	reset_password(ruc, codigo, clave1, clave2) {
		this.enviando = true;
		this.loginService.reset_password(ruc, codigo, clave1, clave2)
			.subscribe(resp => {
				switch (resp.codigo) {
					case '0':
						this.enviando = false;
						this.mensaje.enviarAlerta({ mensaje: resp.mensaje, tipo: 2 });
						break;
					case '1':
						this.enviando = false;
						$("#reset-password").modal("hide");
						this.mensaje.enviarAlerta({ mensaje: "Se modificó correctamente la contraseña.", tipo: 1 });
						break;
				}
			}, error => {
				this.enviando = false;
				this.mensaje.enviarAlerta({ mensaje: error, tipo: 2 });
			})
	}
}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/login/login.component.ts